__turbopack_context__.v({
  "tabHit": "GenderToggle-module__E1XUyG__tabHit",
  "tabLabel": "GenderToggle-module__E1XUyG__tabLabel",
  "thumb": "GenderToggle-module__E1XUyG__thumb" + " " + __turbopack_context__.i(917291)["lbToggleBlur"],
  "track": "GenderToggle-module__E1XUyG__track" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeFrosted"] + " " + __turbopack_context__.i(917291)["lbToggleBlur"],
});
